import {
  Box, Button, SidebarModal,
  SquareIconWithBackground,
} from '@domain-group/suit-theme'

import type { SidebarModalProps } from '@domain-group/suit-theme'
import { faFileCirclePlus, faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'

import useFlipperKey from '@hooks/useFlipperKey'

import CopyFromTemplate from './CopyFromTemplate'

const MODAL_KEY = 'BulkPermissionsModal'

type BulkPermissionsModalProps = {
  callbacks: {
    assignManually?: (payload: {
      additionalTemplatePageIds: number[],
      stepKey: string,
      templatePageId: number,
    }) => void,
    closeModal: () => void,
  },
  selectedTemplateIds: number[],
  showModal: boolean,
}

const BulkPermissionsModal = (props: SidebarModalProps & BulkPermissionsModalProps) => {
  const { callbacks, selectedTemplateIds, showModal } = props

  const [page, setPage] = useState<'copy' | null>(null)

  const { isEnabled: permissionsModalV2Enabled } = useFlipperKey('permissions_modal_v2')

  const handleAssignManually = () => {
    const [firstTemplatePageId, ...additionalTemplatePageIds] = selectedTemplateIds

    callbacks.assignManually?.({
      additionalTemplatePageIds,
      stepKey: permissionsModalV2Enabled ? 'serviceIds' : 'providerIds',
      templatePageId: firstTemplatePageId,
    })
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Assign" titleSecondLine="Permissions" />

      <SidebarModal.Content>
        <Box flexDirection="column">
          {page === null && (
            <>
              <SidebarModal.Button
                iconLeft={
                  <SquareIconWithBackground icon={<FontAwesomeIcon icon={faMagnifyingGlass} />} />
                }
                showAngleIcon
                subtitle="Assign permissions manually"
                title="Assign Manually"
                onClick={handleAssignManually}
              />
              <SidebarModal.Button 
                iconLeft={
                  <SquareIconWithBackground icon={<FontAwesomeIcon icon={faFileCirclePlus} />} />
                }
                showAngleIcon
                subtitle="Copy permissions from a template"
                title="Copy from a Template"
                onClick={() => setPage('copy')}
              />
            </>
          )}

          {page === 'copy' && (
            <CopyFromTemplate callbacks={callbacks} selectedTemplateIds={selectedTemplateIds} />
          )
          }
        </Box>
      </SidebarModal.Content>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: SidebarModalProps & BulkPermissionsModalProps) => (
  <SidebarModal.RenderController {...props}>
    <BulkPermissionsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
